import { Routes } from '@angular/router';
import { scoreboardAdminGuard } from '../../core/guards';

export const statkeeperCliRoutes: Routes = [
  {
    path: 'statkeeper/match/:matchId/cli',
    loadComponent: () =>
      import('./pages/statkeeper-cli/statkeeper-cli.page.component').then(
        (m) => m.StatKeeperCliPageComponent,
      ),
    canActivate: [scoreboardAdminGuard],
  },
];
